var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 629.649,
    height: 457.031,
    viewBox: "0 0 629.649 457.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#2553a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c459c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276bbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#2a6dc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#77a1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#bccce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#080f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6398d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#72a3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#9dc1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afcef2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#bfd7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afcef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#9dc1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#72a3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6398d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcbc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20203",
    "data-name": "Group 20203",
    transform: "translate(-497.981 -174.119)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102659",
    "data-name": "Path 102659",
    d: "M578.1,418.515c-50.274,0-91.031,8.067-91.031,18.017s40.757,18.017,91.031,18.017,91.033-8.064,91.033-18.017S628.374,418.515,578.1,418.515Z",
    transform: "translate(80.121 176.602)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102668",
    "data-name": "Path 102668",
    d: "M680.67,357.477c-14.966,4.7-47.723,19.583-62.191,48.686,0,0,33.873-41.394,82.2-41.394,41.637,0,99.73,27.7,105.153,50.348l16.845-14.692S761.379,332.093,680.67,357.477Z",
    transform: "translate(175.078 128.411)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102670",
    "data-name": "Path 102670",
    d: "M673.147,371.381c-13.495,4.248-31.856,16-27.868,35.041-.536-4.27-.245-21.419,37.933-25.188,35.083-3.466,85.433,15.731,97.9,36.214h5.976l9.94-11.622S742.477,349.555,673.147,371.381Z",
    transform: "translate(194.043 138.908)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102671",
    "data-name": "Path 102671",
    d: "M645.218,390.585c-.081-.331-.105-.643-.172-.972A7.576,7.576,0,0,0,645.218,390.585Z",
    transform: "translate(194.276 155.717)",
    fill: "#e1ecf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102672",
    "data-name": "Path 102672",
    d: "M660.833,341.234s25.77-2.009,41.782,20.034c18.458,25.419,62.753,77.126,77.1,77.126,43.916,0-20.706-96.469-32.4-110.288C722.5,298.792,660.833,341.234,660.833,341.234Z",
    transform: "translate(205.684 103.813)",
    fill: "#e1ecf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102673",
    "data-name": "Path 102673",
    d: "M731.534,413.313h47.528c-6.987-5.883-10.356-28.769,0-41.239C779.062,372.074,731.229,387.66,731.534,413.313Z",
    transform: "translate(256.771 143.043)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102674",
    "data-name": "Path 102674",
    d: "M854.08,375.372c-19.1-12.15-39.372-5.345-46.383-6.012-71.946-6.828-77.9,36.4-82,46.857h10.4c2.775-21.434,47.5-54.867,66.646-17.717,20.4,39.577,63.507,50.438,63.507,50.438.043-.105.109-.21.15-.317C881.052,418.05,877.282,390.151,854.08,375.372Z",
    transform: "translate(252.553 140.14)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102675",
    "data-name": "Path 102675",
    d: "M819.681,375.787c-19.1-12.15-39.61-7.936-46.383-6.012,17.223,1.444,37.307,11.922,44.266,22.156,15.845,23.295,17.672,40.357,14.439,57.1C846.653,418.465,842.883,390.565,819.681,375.787Z",
    transform: "translate(286.952 139.725)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102678",
    "data-name": "Path 102678",
    d: "M709.479,315.948s-12.759-14.325-38.4-3.428-28.054,44.107-12.193,68.53c0,0,32.5-6.554,49.341-30.277,16.84-23.7,51.325-11.543,51.325-11.543S739.018,303.671,709.479,315.948Z",
    transform: "translate(197.083 97.054)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102679",
    "data-name": "Path 102679",
    d: "M671.077,312.52c-25.641,10.89-28.054,44.107-12.193,68.53,20.818-66.418,50.595-65.1,50.595-65.1S696.719,301.623,671.077,312.52Z",
    transform: "translate(197.083 97.054)",
    fill: "#4a85f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102681",
    "data-name": "Path 102681",
    d: "M557.856,394.378a7.372,7.372,0,0,0,7.371,7.373h83.422V387.009H565.227A7.371,7.371,0,0,0,557.856,394.378Z",
    transform: "translate(131.272 153.836)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102682",
    "data-name": "Path 102682",
    d: "M671.287,348.5H587.105l-2.713,28.063a14.3,14.3,0,0,0,4.122,11.486l26.726,26.785h81.605l-26.635-32.09Z",
    transform: "translate(150.399 126.009)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102683",
    "data-name": "Path 102683",
    d: "M585.248,360.8h84.986l.386-12.3H586.439Z",
    transform: "translate(151.066 126.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102684",
    "data-name": "Path 102684",
    d: "M664.706,377.627l2.975-29.126h-14.8l-2.715,28.063a14.306,14.306,0,0,0,4.12,11.486l26.787,26.785h-69.2a7.371,7.371,0,1,0,0,14.742h70.277a14.29,14.29,0,0,0,14-11.392,14.839,14.839,0,0,0-4.327-13.433Z",
    transform: "translate(164.978 126.009)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102685",
    "data-name": "Path 102685",
    d: "M912.953,179.412H533.313a24.646,24.646,0,0,0-24.552,22.5L487.618,444.163a24.644,24.644,0,0,0,24.552,26.785H891.812a24.646,24.646,0,0,0,24.551-22.5L937.506,206.2A24.645,24.645,0,0,0,912.953,179.412Z",
    transform: "translate(80.449 3.825)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102686",
    "data-name": "Path 102686",
    d: "M906.008,179.4H526.381a24.577,24.577,0,0,0-24.158,20.015,25.036,25.036,0,0,0-.374,2.527L480.677,444.171a24.638,24.638,0,0,0,24.571,26.766h379.63a24.625,24.625,0,0,0,24.571-22.5l21.131-242.231A24.674,24.674,0,0,0,906.008,179.4Z",
    transform: "translate(75.435 3.817)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102687",
    "data-name": "Path 102687",
    d: "M899.838,187.978H520.186a9.816,9.816,0,0,0-9.845,9.028L489.181,439.251a9.929,9.929,0,0,0,9.881,10.765h379.65a9.819,9.819,0,0,0,9.846-9.028l21.159-242.242a9.927,9.927,0,0,0-9.879-10.768Z",
    transform: "translate(81.621 10.015)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102688",
    "data-name": "Path 102688",
    d: "M891.477,187.978H511.824a9.816,9.816,0,0,0-9.845,9.028l-1.263,14.31H900.263l1.092-12.57a9.927,9.927,0,0,0-9.879-10.768Z",
    transform: "translate(89.983 10.015)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102689",
    "data-name": "Path 102689",
    d: "M552.745,203.387H776.859l1.26-12.168H554Z",
    transform: "translate(127.578 12.356)",
    fill: "#1a6cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20192",
    "data-name": "Group 20192",
    transform: "translate(600.083 205.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20185",
    "data-name": "Group 20185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20182",
    "data-name": "Group 20182",
    transform: "translate(0 0.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102690",
    "data-name": "Path 102690",
    d: "M508.071,192.674a.835.835,0,0,0-1.183,0,.844.844,0,0,0-.1,1.182l7.643,8.377a.877.877,0,0,0,1.288-1.182Z",
    transform: "translate(-505.857 -192.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102691",
    "data-name": "Path 102691",
    d: "M515.569,192.674l-9.106,8.377a.8.8,0,1,0,1.078,1.182l9.107-8.377a.844.844,0,0,0,.1-1.182A.833.833,0,0,0,515.569,192.674Z",
    transform: "translate(-506.164 -192.428)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20183",
    "data-name": "Group 20183",
    transform: "translate(16.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102692",
    "data-name": "Path 102692",
    d: "M521.82,192.068a6.28,6.28,0,0,0-6.134,5.645,5.09,5.09,0,0,0,5.149,5.647,6.282,6.282,0,0,0,6.136-5.647A5.09,5.09,0,0,0,521.82,192.068Zm-.875,10.012a3.941,3.941,0,0,1-3.984-4.367,4.868,4.868,0,0,1,4.749-4.365,3.941,3.941,0,0,1,3.983,4.365A4.864,4.864,0,0,1,520.945,202.08Z",
    transform: "translate(-515.664 -192.068)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20184",
    "data-name": "Group 20184",
    transform: "translate(32.578 9.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102693",
    "data-name": "Path 102693",
    d: "M535.951,197.361H525.774a.711.711,0,0,0-.7.636.578.578,0,0,0,.586.641h10.177a.71.71,0,0,0,.692-.641A.573.573,0,0,0,535.951,197.361Z",
    transform: "translate(-525.076 -197.361)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20187",
    "data-name": "Group 20187",
    transform: "translate(362.193 8.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20186",
    "data-name": "Group 20186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102694",
    "data-name": "Path 102694",
    d: "M727.295,197.148H717.118a.713.713,0,0,0-.692.641.574.574,0,0,0,.582.639h10.174a.708.708,0,0,0,.7-.639A.577.577,0,0,0,727.295,197.148Z",
    transform: "translate(-716.422 -197.148)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20189",
    "data-name": "Group 20189",
    transform: "translate(362.522 5.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20188",
    "data-name": "Group 20188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102695",
    "data-name": "Path 102695",
    d: "M727.484,194.974H717.309a.709.709,0,0,0-.693.639.576.576,0,0,0,.581.641h10.177a.712.712,0,0,0,.693-.641A.576.576,0,0,0,727.484,194.974Z",
    transform: "translate(-716.614 -194.974)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20191",
    "data-name": "Group 20191",
    transform: "translate(362.847 1.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20190",
    "data-name": "Group 20190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102696",
    "data-name": "Path 102696",
    d: "M727.675,192.8H717.5a.708.708,0,0,0-.694.639.576.576,0,0,0,.584.639h10.174a.711.711,0,0,0,.694-.639A.574.574,0,0,0,727.675,192.8Z",
    transform: "translate(-716.803 -192.8)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20193",
    "data-name": "Group 20193",
    transform: "translate(527.624 332.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102697",
    "data-name": "Path 102697",
    d: "M470.875,288.046a7.581,7.581,0,0,0,1.571,15.08c9.039-.91,23.141-3.13,31.925-7.311l-1.592-9.357C498.474,287.2,484.929,286.541,470.875,288.046Z",
    transform: "translate(-464.101 -251.643)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102698",
    "data-name": "Path 102698",
    d: "M516.607,273.837a1.8,1.8,0,0,0-.777-2.546c.572-.977-.286-1.666-1.147-1.76.941-1.544,1.6-2.892.224-3.276-.67-.191-3,3.983-4.034,5.4-1.757,2.394-3.02.488-4.215,2.672-1.3,2.365-.836,4.245-.744,6.41.062,1.449-.755,2.3-1.38,3.39-2.677,4.679-11.672,11.733-19.123,18.513-2.556,2.322.224,8.241,2.829,8.112,6.57-.327,17.738-18.492,22.173-24.368,3.385-4.487,4.851-7.457,6.138-9.092C517.753,275.762,517.882,274.6,516.607,273.837Z",
    transform: "translate(-449.434 -266.247)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102699",
    "data-name": "Path 102699",
    d: "M505.861,273.837a1.8,1.8,0,0,0-.777-2.546c.572-.977-.286-1.666-1.147-1.76.941-1.544,1.6-2.892.224-3.276-.67-.191-3,3.983-4.034,5.4-.734,1-1.905,4.63,1.063,6.577,1.855,1.214,4.133-.326,4.615-.941C507.007,275.762,507.136,274.6,505.861,273.837Z",
    transform: "translate(-438.687 -266.247)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102700",
    "data-name": "Path 102700",
    d: "M504.381,276.516c-2.677,4.675-12.677,12.258-20.129,19.04-2.555,2.324,1.633,8.945,4.239,8.816,6.513-.327,18.866-17.6,23.371-23.631-1.99-.6-5.557-3.5-6.994-4.968C504.7,276.017,504.528,276.26,504.381,276.516Z",
    transform: "translate(-450.113 -259.363)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102701",
    "data-name": "Path 102701",
    d: "M520.906,280.531c-5.335,4.386-14.43,12.291-19.391,15.962-5.812,4.307-10.973,3.223-17.588,4.072-6.99.9-12.294,4.849-18.769,4.365,1.736,2.56,4.16,2.849,6.525,2.611,8.415-.848,21.212-2.83,30.027-6.477l.007,0c5.35-.269,14.642-11.974,20.285-19.488A.764.764,0,0,0,520.906,280.531Z",
    transform: "translate(-463.337 -256.059)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102702",
    "data-name": "Path 102702",
    d: "M499.36,266.727a19.67,19.67,0,0,1-1.786,4.479l-.739,5.306,2.432-1.65a6.586,6.586,0,0,0,.391-4.022C500.682,269.13,500.5,267.612,499.36,266.727Z",
    transform: "translate(-440.447 -265.901)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102703",
    "data-name": "Path 102703",
    d: "M473.414,284.832c2.027-3.368-2.963-5.76-6.677-7.25q-3.292-1.318-6.691-2.329a1.3,1.3,0,0,0-1.254.078c-.384.374-.164,1.02.088,1.49,1.714,3.189,1,14.339-.3,18.775-.088.3,15.507,2.613,15.507,2.613S470.921,288.966,473.414,284.832Z",
    transform: "translate(59.537 72.993)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102704",
    "data-name": "Path 102704",
    d: "M468.6,278.954c-1.885-.724-6.62-3.125-8.556-3.7a1.3,1.3,0,0,0-1.254.078c-.384.374-.164,1.02.088,1.49,1.714,3.189,1,14.339-.3,18.775-.06.207,7.436,1.385,12.022,2.088C468.5,294.47,467.147,283.769,468.6,278.954Z",
    transform: "translate(59.537 72.993)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102705",
    "data-name": "Path 102705",
    d: "M480.307,276.848c-2.691-1.6-5.354-5.922-6.336-8.344-2.543-6.281-11.888-3.7-15.028,2.99-1.612,3.442-1.4,7.5-.312,11.147,1.376,4.629,4.346,9.028,8.789,10.913,1.43.6,8.491,1.876,10.146.87,2.312-1.4,2.238-11.419,3.352-14.155C481.879,277.905,480.975,277.246,480.307,276.848Z",
    transform: "translate(58.953 65.611)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102706",
    "data-name": "Path 102706",
    d: "M463.344,285.523a15.1,15.1,0,0,1-2.8-15.181,11.548,11.548,0,0,1,2.935-4.518,11.849,11.849,0,0,0-4.539,5.016c-1.612,3.442-1.4,7.5-.312,11.147,1.376,4.629,4.346,9.028,8.789,10.913,1.337.567,7.605,1.717,9.764,1.039a14.7,14.7,0,0,1-2.718-.367C470.233,292.548,466.073,288.846,463.344,285.523Z",
    transform: "translate(58.953 66.266)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102707",
    "data-name": "Path 102707",
    d: "M470.257,263.566c-15.161-2.708-18.458,7.819-18.146,15.8.319,8.189,8.7,15.193,12.089,16.261.451.14,6.749.426,10.234-7.225.7-1.535,1.109-3.059.336-3.493-2.76-1.547-3.816-6.045-2.667-7.185,1.778-1.757,2.61,1.206,3.778.315,1.034-.787,2.432-6.343.882-9.312A10.1,10.1,0,0,0,470.257,263.566Z",
    transform: "translate(54.846 64.321)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102708",
    "data-name": "Path 102708",
    d: "M461.917,279.979c.138-1.283,1.015-4.027,1.285-5.29,1.173-5.552-3.781-10.034-8.417-7.232-2.749,1.662-4.878,11.159,1.016,18.671,2.191,2.794,6.78,7.052,9.247,7.049C467.613,293.169,461.379,285.164,461.917,279.979Z",
    transform: "translate(54.807 66.826)",
    fill: "#3e4654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102709",
    "data-name": "Path 102709",
    d: "M455.256,265.9a8.365,8.365,0,0,0,0,16.73c4.622,0,6.248-3.745,6.248-8.363S459.878,265.9,455.256,265.9Z",
    transform: "translate(51.089 66.319)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20194",
    "data-name": "Group 20194",
    transform: "translate(556.727 561.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102710",
    "data-name": "Path 102710",
    d: "M503.371,409.238c-4.091-1.471-9.54-4.487-11.269-6.067a5.857,5.857,0,0,1-1.452-4.213,9.636,9.636,0,0,1-4.088.8,11.9,11.9,0,0,1-4.119-.742c-.112,2.345-.074,4.7-.358,7.02-.145,1.137-.413,2.358.16,3.335.761,1.3,2.572,1.444,4.072,1.466,3.407.048,6.816.255,10.2.63,2.921.3,5.941.739,8.737-.207.567-.177,1.225-.634,1.028-1.207A16.2,16.2,0,0,1,503.371,409.238Z",
    transform: "translate(-480.346 -398.958)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102711",
    "data-name": "Path 102711",
    d: "M503.371,409.212a1.027,1.027,0,0,1-.257-.083,15.2,15.2,0,0,1-3.86.289c-5.676-.289-11.231-4.158-12.692-9.683a11.9,11.9,0,0,1-4.119-.742c-.112,2.345-.074,4.7-.358,7.02-.145,1.137-.413,2.358.16,3.335.761,1.3,2.572,1.444,4.072,1.466,3.407.048,6.816.255,10.2.631,2.921.3,5.941.739,8.737-.207.567-.177,1.225-.634,1.028-1.207A16.206,16.206,0,0,1,503.371,409.212Z",
    transform: "translate(-480.346 -398.932)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102712",
    "data-name": "Path 102712",
    d: "M507.7,407.388c-.6-.257-5.95-2.193-8.99-3.261-1.139-.4-2.019,1.158-2.022,2.076-6.923-.026-12.94-4.716-13.891-4.015-1.757,1.3-3.121,5.385.355,6.968.453.207,1.542.334,5.223.351,3.3.012,6.549,1.905,8.594,1.916l10.746.04C508.865,411.469,509.642,408.208,507.7,407.388Z",
    transform: "translate(-480.995 -396.676)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102713",
    "data-name": "Path 102713",
    d: "M506.257,408.259c-4.446.7-9.495-.312-13.912-1.009a28.763,28.763,0,0,1-10.916-4.01c-.753,1.736-.686,4.014,1.717,5.106.453.207,1.542.334,5.223.351,3.3.012,6.549,1.905,8.594,1.916l10.747.04c1.018.007,1.733-2.544.541-3.7A2.707,2.707,0,0,1,506.257,408.259Z",
    transform: "translate(-480.989 -395.865)",
    fill: "#0e182a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102714",
    "data-name": "Path 102714",
    d: "M489.07,407.3l-7.982-2.332,1.685,4.334,6.758.031A3.933,3.933,0,0,1,489.07,407.3Z",
    transform: "translate(-480.929 -394.616)",
    fill: "#0e182a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102715",
    "data-name": "Path 102715",
    d: "M484,398.651v-.021c-.124.057-.227.145-.353.205C483.772,398.775,483.875,398.711,484,398.651Z",
    transform: "translate(77.647 162.233)",
    fill: "#c9b1c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102716",
    "data-name": "Path 102716",
    d: "M467.269,405.06c-1.931-1.755-1.351-5.176-1.487-7.39-.16-2.586-7.857-.4-7.914-.01-.489,3.414-.189,6.9-.6,10.322-.134,1.12-.4,2.344.177,3.319.768,1.3,2.567,1.44,4.083,1.457q5.108.052,10.2.58c2.923.3,5.955.718,8.74-.227.556-.19,1.209-.655,1.015-1.213C477.72,411.346,469.491,407.075,467.269,405.06Z",
    transform: "translate(58.458 160.64)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102717",
    "data-name": "Path 102717",
    d: "M461.262,397.24c.1-.25.236-.487.358-.727a10.46,10.46,0,0,0-3.752,1.084c-.489,3.414-.189,6.9-.6,10.322-.134,1.12-.4,2.344.177,3.319.768,1.3,2.567,1.44,4.083,1.457,3.159.034,6.315.217,9.461.522C464.748,410.333,458.221,404.618,461.262,397.24Z",
    transform: "translate(58.458 160.703)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102718",
    "data-name": "Path 102718",
    d: "M482.9,407.345c-.6-.253-5.96-2.169-9-3.221-1.14-.4-2.017,1.161-2.017,2.079-6.918,0-12.954-4.661-13.9-3.952-1.752,1.3-3.1,5.4.381,6.959.455.207,1.543.331,5.225.331,3.294,0,6.554,1.878,8.6,1.878h10.747C484.083,411.419,484.843,408.152,482.9,407.345Z",
    transform: "translate(57.807 164.796)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102719",
    "data-name": "Path 102719",
    d: "M481.062,408.324a11.165,11.165,0,0,1-5.741-.015c-1.3-.351-9-1.283-11.452-1.413a8.305,8.305,0,0,1-6.9-4c-1.092,1.773-1.361,4.561,1.385,5.795.455.207,1.543.331,5.225.331,3.294,0,6.554,1.878,8.6,1.878h10.747c1.008,0,1.716-2.52.549-3.685A8.092,8.092,0,0,1,481.062,408.324Z",
    transform: "translate(57.81 165.316)",
    fill: "#0e182a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102720",
    "data-name": "Path 102720",
    d: "M459.069,376.056c.98,16.739-2.062,21.347-2.834,30.985-.784,9.774,1.523,46.751,1.523,46.751s5.657,1.628,10.3,0l15.564-123.268-28.156-2.6S458.087,359.319,459.069,376.056Z",
    transform: "translate(57.286 111.138)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102721",
    "data-name": "Path 102721",
    d: "M455.975,333.317c.851,10.6,2.2,27.87,2.841,38.84.98,16.739-2.062,21.347-2.834,30.985-.784,9.774,1.523,46.751,1.523,46.751a22.654,22.654,0,0,0,5.3.724c-1.025-13.76-3.38-26.616,2.148-38.133,1.757-3.657,2.425-14.279,2.425-18.649,0-8.8-2.336-23.794,1.268-36.245.722-2.5,1.178-11.169,1.45-18.857-.059,0-.112.007-.172.007A19.086,19.086,0,0,1,455.975,333.317Z",
    transform: "translate(57.54 115.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102722",
    "data-name": "Path 102722",
    d: "M462.286,329.776a10.619,10.619,0,0,0,.6,5.965c1.847,5.126,18.909,51.735,18.694,55.864-.8,15.447,8.272,29.355,15.031,61.378,2.637.922,7.791,1.662,10.406-1.171-1.1-17.071-14.268-109.837-15.839-121.049C491,330.641,470.27,332.956,462.286,329.776Z",
    transform: "translate(62.059 112.479)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102723",
    "data-name": "Path 102723",
    d: "M495.2,415.131c-2.129-5.309-7.378-16.618-8.546-22.416-1.375-6.815-.775-26.671-2.065-33.1-.887-4.384-1.218-8.98-3.218-12.835-1.137-2.195-2.734-3.745-4.065-5.673-.214,0-.415.029-.634.029A19.375,19.375,0,0,1,463.8,336.7c5.075,14.034,16.708,46.486,16.53,49.9-.8,15.447,8.272,29.355,15.031,61.378,1.5.525,3.652,1.385,5.564.8-1.662-5.058-1.952-12.439-2.76-17.13C497.133,425.7,497.445,420.75,495.2,415.131Z",
    transform: "translate(63.307 117.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102724",
    "data-name": "Path 102724",
    d: "M495.181,311.492c0-4.415-9.6-17.8-15.288-21.34s-7.729-5.619-14.963-4.327c-7.848,1.4-6.291,12.923-6.291,35.6,0,1.788-3.635,40.64-4.189,43.932,6.32,4.417,36.8,3.924,43.951,1.493,0-19.753-5-33.525-5-42.845C493.4,320.758,495.181,318.367,495.181,311.492Z",
    transform: "translate(56.55 80.44)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102725",
    "data-name": "Path 102725",
    d: "M464.93,285.678c-8.184,2.267-6.291,12.923-6.291,35.6,0,1.788-3.635,40.64-4.189,43.932,2.711,1.9,9.523,2.934,16.981,3.319,0-8.956-6.324-12.243-6.324-20.1,0-4.858,5.848-9.993,5.481-13.838-.687-7.254-2.427-25.508.842-36.34C472.468,294.813,467.469,284.975,464.93,285.678Z",
    transform: "translate(56.55 80.587)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102726",
    "data-name": "Path 102726",
    d: "M456.283,405.03l1.7,4.327h6.758a3.9,3.9,0,0,1-.467-2.029Z",
    transform: "translate(57.874 166.858)",
    fill: "#0e182a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102727",
    "data-name": "Path 102727",
    d: "M756.262,210.968H680.729a4.152,4.152,0,0,0-4.067,3.805,3.51,3.51,0,0,0,3.536,3.8h75.533a4.156,4.156,0,0,0,4.067-3.8A3.509,3.509,0,0,0,756.262,210.968Z",
    transform: "translate(217.115 26.627)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102728",
    "data-name": "Path 102728",
    d: "M730.336,222.454H714.959a3.239,3.239,0,0,0-3.17,2.959,2.735,2.735,0,0,0,2.756,2.963h15.378a3.235,3.235,0,0,0,3.166-2.963A2.732,2.732,0,0,0,730.336,222.454Z",
    transform: "translate(242.5 34.927)",
    fill: "#c5d9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102729",
    "data-name": "Path 102729",
    d: "M745.313,233.18H689.358a2.009,2.009,0,0,0-1.969,1.841,1.7,1.7,0,0,0,1.71,1.836h55.955a2.01,2.01,0,0,0,1.971-1.836A1.7,1.7,0,0,0,745.313,233.18Z",
    transform: "translate(224.87 42.678)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102730",
    "data-name": "Path 102730",
    d: "M744.7,241.884H688.747a2.007,2.007,0,0,0-1.966,1.841,1.7,1.7,0,0,0,1.712,1.84h55.952a2.013,2.013,0,0,0,1.971-1.84A1.7,1.7,0,0,0,744.7,241.884Z",
    transform: "translate(224.431 48.967)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102731",
    "data-name": "Path 102731",
    d: "M744.1,250.59H688.142a2.012,2.012,0,0,0-1.971,1.841,1.7,1.7,0,0,0,1.712,1.838h55.955a2.009,2.009,0,0,0,1.971-1.838A1.7,1.7,0,0,0,744.1,250.59Z",
    transform: "translate(223.991 55.258)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102732",
    "data-name": "Path 102732",
    d: "M743.487,259.294H687.534a2.012,2.012,0,0,0-1.969,1.84,1.7,1.7,0,0,0,1.714,1.843h55.952a2.01,2.01,0,0,0,1.971-1.843A1.7,1.7,0,0,0,743.487,259.294Z",
    transform: "translate(223.552 61.548)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102733",
    "data-name": "Path 102733",
    d: "M727.3,268H708.486a2.01,2.01,0,0,0-1.967,1.838,1.7,1.7,0,0,0,1.712,1.843h18.814a2.01,2.01,0,0,0,1.967-1.843A1.7,1.7,0,0,0,727.3,268Z",
    transform: "translate(238.693 67.838)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102734",
    "data-name": "Path 102734",
    d: "M702.181,268H697.8a2.01,2.01,0,0,0-1.969,1.838,1.7,1.7,0,0,0,1.71,1.843h4.381a2.012,2.012,0,0,0,1.969-1.843A1.7,1.7,0,0,0,702.181,268Z",
    transform: "translate(230.971 67.838)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102735",
    "data-name": "Path 102735",
    d: "M742.277,276.7H686.32a2.011,2.011,0,0,0-1.971,1.84,1.7,1.7,0,0,0,1.712,1.838h55.957a2.011,2.011,0,0,0,1.969-1.838A1.7,1.7,0,0,0,742.277,276.7Z",
    transform: "translate(222.673 74.129)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102736",
    "data-name": "Path 102736",
    d: "M720.106,325.632H703.13a2.8,2.8,0,0,0-2.747,2.562,2.37,2.37,0,0,0,2.388,2.567h16.98a2.8,2.8,0,0,0,2.746-2.567A2.368,2.368,0,0,0,720.106,325.632Z",
    transform: "translate(234.258 109.484)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102737",
    "data-name": "Path 102737",
    d: "M720.6,318.522H703.626a2.806,2.806,0,0,0-2.748,2.568,2.369,2.369,0,0,0,2.389,2.561h16.978a2.8,2.8,0,0,0,2.744-2.561A2.366,2.366,0,0,0,720.6,318.522Z",
    transform: "translate(234.616 104.346)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102738",
    "data-name": "Path 102738",
    d: "M721.1,311.413H704.123a2.805,2.805,0,0,0-2.748,2.567,2.364,2.364,0,0,0,2.386,2.563h16.981a2.8,2.8,0,0,0,2.744-2.563A2.367,2.367,0,0,0,721.1,311.413Z",
    transform: "translate(234.975 99.209)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102739",
    "data-name": "Path 102739",
    d: "M721.594,304.3h-16.98a2.8,2.8,0,0,0-2.741,2.567,2.369,2.369,0,0,0,2.384,2.567h16.98a2.8,2.8,0,0,0,2.742-2.567A2.366,2.366,0,0,0,721.594,304.3Z",
    transform: "translate(235.335 94.072)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102740",
    "data-name": "Path 102740",
    d: "M698.549,304.3h-11a2.8,2.8,0,0,0-2.746,2.567,2.375,2.375,0,0,0,2.388,2.567h11a2.8,2.8,0,0,0,2.744-2.567A2.366,2.366,0,0,0,698.549,304.3Z",
    transform: "translate(223 94.072)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102741",
    "data-name": "Path 102741",
    d: "M697.453,320.023h-11a2.808,2.808,0,0,0-2.748,2.568,2.369,2.369,0,0,0,2.389,2.562h11a2.806,2.806,0,0,0,2.746-2.562A2.371,2.371,0,0,0,697.453,320.023Z",
    transform: "translate(222.207 105.431)",
    fill: "#8dc4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102742",
    "data-name": "Path 102742",
    d: "M750.7,293.569c-8.275-4.653-43.768-10.957-48.285-11.617-6.031-.885-7.08,9.259-5.244,11.4,2.4,2.8,8.773,6.363,19.733,9.144,8.453,2.152,24.811,9.4,30.327,3.4C750.8,302.012,759.638,298.6,750.7,293.569Z",
    transform: "translate(231.354 77.881)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102743",
    "data-name": "Path 102743",
    d: "M727.495,293.043c-8.4-2.091-11.7-8.883-20.129-5.145-4.131,1.829-12.019.618-10.448,2.451,2.4,2.8,11.629,6.417,19.733,8.606,14.3,3.876,21.941,7.772,27.091,3.3C746.964,299.455,739.886,296.13,727.495,293.043Z",
    transform: "translate(231.612 81.42)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102744",
    "data-name": "Path 102744",
    d: "M690.885,272.1a23.053,23.053,0,0,0-5.585-7.292c-1.2-1.1-3.416-2.9-4.539-3.878-.927-.808-2.182,1.287-1.044,2.513-.765.248-1.583,2.083-.882,2.854a2.384,2.384,0,0,0-.427,3c-1.016.925-.892,2.231.484,3.4,1.466,1.247,2.872,3.066,6.77,6.515.648.574,1.683,1.978,2.257,2.529a55.231,55.231,0,0,1,6.031-6.465C693.279,274.622,691.483,273.513,690.885,272.1Z",
    transform: "translate(217.899 62.598)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102745",
    "data-name": "Path 102745",
    d: "M681.407,263.437c-.048,2.1-1.456,6.184-3.151,7.207v.034a26.162,26.162,0,0,1,2.253,2.146,3.877,3.877,0,0,0,4.484.732,7.394,7.394,0,0,1,2.11-.584c1.376-.2,1.9-2.009,1.2-3.307C686.664,266.62,681.436,262.26,681.407,263.437Z",
    transform: "translate(218.274 64.399)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102746",
    "data-name": "Path 102746",
    d: "M709.405,286.681c-5.306-4.257-19.693-18.883-19.693-18.883a86.109,86.109,0,0,0-7.736,8.689s17.316,19.414,23.712,25.972c9.684,9.938,15.338-1.135,14.055-5.368C718.556,293.189,712.771,289.377,709.405,286.681Z",
    transform: "translate(220.962 67.693)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102747",
    "data-name": "Path 102747",
    d: "M685.158,270.606c-.98,1.128-2.057,2.417-3.182,3.852,0,0,17.316,19.414,23.712,25.972,7.919,8.127,14.3,4.045,14.234-1.482-6.343-4.946-14.82-6.816-23.679-14.926C693.33,281.352,688.21,272.635,685.158,270.606Z",
    transform: "translate(220.962 69.722)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20195",
    "data-name": "Group 20195",
    transform: "translate(984.571 582.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102748",
    "data-name": "Path 102748",
    d: "M761.221,412.936c-.076-.508-9.972-3.318-10.177.016-.176,2.844.572,7.244-1.916,9.5-2.856,2.591-13.442,8.082-18.282,8.792-.248.718.589,1.32,1.306,1.562,3.581,1.214,7.481.682,11.245.293q6.537-.68,13.119-.746c1.948-.024,4.262-.2,5.251-1.876.737-1.252.4-2.827.226-4.269C761.468,421.807,761.849,417.32,761.221,412.936Z",
    transform: "translate(-728.328 -411.346)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102749",
    "data-name": "Path 102749",
    d: "M755.541,412.855c-.036-.25-2.393-1.034-4.827-1.4.159.308.329.611.46.939,3.914,9.485-4.482,16.839-12.511,20.551,4.048-.394,8.107-.634,12.174-.672,1.948-.024,4.262-.2,5.251-1.876.737-1.252.4-2.827.226-4.269C755.787,421.726,756.168,417.239,755.541,412.855Z",
    transform: "translate(-722.647 -411.265)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102750",
    "data-name": "Path 102750",
    d: "M762.957,418.838c-1.22-.911-8.982,5.087-17.886,5.087,0-1.182-1.123-3.187-2.594-2.675-3.914,1.352-10.806,3.819-11.578,4.14-2.5,1.046-1.521,5.247-.041,5.247H744.68c2.632,0,6.83-2.419,11.068-2.419,4.732,0,6.133-.162,6.72-.426C766.945,425.778,765.21,420.515,762.957,418.838Z",
    transform: "translate(-729.366 -406.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102751",
    "data-name": "Path 102751",
    d: "M755.377,424.815c-3.152.165-13.061,1.363-14.734,1.814a14.393,14.393,0,0,1-7.387.021,10.564,10.564,0,0,1-3.113-1.423c-1.5,1.493-.589,4.739.711,4.739h13.822c2.632,0,6.83-2.419,11.068-2.419,4.732,0,6.133-.162,6.72-.426,3.533-1.588,3.183-5.173,1.78-7.452A10.685,10.685,0,0,1,755.377,424.815Z",
    transform: "translate(-729.364 -405.331)",
    fill: "#0e182a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102752",
    "data-name": "Path 102752",
    d: "M743.762,427.984h8.7l2.188-5.571-10.282,2.958A5.021,5.021,0,0,1,743.762,427.984Z",
    transform: "translate(-718.963 -403.349)",
    fill: "#0e182a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20196",
    "data-name": "Group 20196",
    transform: "translate(909.346 581.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102753",
    "data-name": "Path 102753",
    d: "M714,411.19c-1.39,2.482-2.629,6.775-5.848,7.731-3.7,1.1-15.614,1.45-20.289-.007-.534.539-.038,1.444.5,1.972,2.7,2.648,6.448,3.864,10,5.14q6.186,2.22,12.144,5.02c1.766.829,3.926,1.674,5.547.586,1.208-.808,1.586-2.372,2.055-3.75,1.437-4.193,3.729-8.067,5.063-12.3C723.336,415.1,715.635,408.278,714,411.19Z",
    transform: "translate(-684.293 -410.469)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102754",
    "data-name": "Path 102754",
    d: "M714.565,411.494c.005.351.028.694.005,1.049-.589,10.241-11.342,13.226-20.185,13.087,3.815,1.4,7.576,2.947,11.257,4.677,1.766.829,3.926,1.674,5.547.586,1.208-.808,1.586-2.372,2.055-3.75,1.437-4.193,3.729-8.067,5.063-12.3C718.381,414.609,716.6,412.879,714.565,411.494Z",
    transform: "translate(-679.417 -409.729)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102755",
    "data-name": "Path 102755",
    d: "M702.011,419.684c.513-1.063.37-3.361-1.173-3.538-4.114-.477-11.392-1.245-12.229-1.29-2.706-.14-3.645,4.067-2.315,4.711,1.106.531,8.372,4.027,12.458,5.995,2.372,1.14,7.2.78,11.018,2.618,4.267,2.057,5.6,2.522,6.239,2.536,4.909.129,5.629-5.368,4.327-7.86C719.633,421.51,710.035,423.546,702.011,419.684Z",
    transform: "translate(-685.696 -407.302)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102756",
    "data-name": "Path 102756",
    d: "M710.622,425.505c-2.911-1.221-12.358-4.434-14.062-4.758a14.346,14.346,0,0,1-6.661-3.185,10.477,10.477,0,0,1-2.189-2.632c-2,.7-2.586,4.015-1.416,4.58l12.458,5.995c2.372,1.14,7.2.78,11.018,2.618,4.267,2.057,5.6,2.522,6.239,2.536,3.871.1,5.114-3.28,4.837-5.941A10.7,10.7,0,0,1,710.622,425.505Z",
    transform: "translate(-685.696 -407.246)",
    fill: "#0e182a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102757",
    "data-name": "Path 102757",
    d: "M698.235,424.334l7.834,3.772,4.388-4.07-10.546-1.793A5.043,5.043,0,0,1,698.235,424.334Z",
    transform: "translate(-676.635 -401.962)",
    fill: "#0e182a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102758",
    "data-name": "Path 102758",
    d: "M732.942,330.337c-7.171,26.878-26.468,122.369-32.926,142.782,2.474,4.8,8.544,7.387,14.222,6.394,3.967-7.182,40.426-112.617,47.424-138.72C761.923,339.818,740.54,331.145,732.942,330.337Z",
    transform: "translate(233.998 112.884)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102759",
    "data-name": "Path 102759",
    d: "M748.229,333.144c-3.426,12.289-.088,27.281-8.377,37.182-5.156,6.158-5.328,15.409-5.312,23.648a36.311,36.311,0,0,1-4.847,18.594c-3.538,5.757-6.987,9.436-7.857,16.578-.848,6.949-3.752,16.713-5.158,23.612-2.5,12.279-10.467,10.206-15.073,21.7a14.263,14.263,0,0,0,11.484,3.027c3.967-7.182,40.426-112.617,47.424-138.72C760.651,338.253,754.865,335.64,748.229,333.144Z",
    transform: "translate(235.146 114.912)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102760",
    "data-name": "Path 102760",
    d: "M761.547,335.532c-5.959-1.209-32.335-4.587-35.222,1.347-4.349,8.94,22.492,130.047,25.064,139.741,5.175,2.239,11.9.82,14.8-.734-.835-25.3-5.032-45.334-5.757-67.259C759.571,382.627,762.208,355.51,761.547,335.532Z",
    transform: "translate(252.664 115.153)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102761",
    "data-name": "Path 102761",
    d: "M751.25,335.7c-1.947-.394-6.205-1.438-11.15-2.462,1.945,2.949,1.822,19.676,1.733,21.243-.646,11.61,3.869,23.958,3.542,26.585-1.838,14.708,1.118,24.284,1.035,28.649-.091,4.911-2.257,13.994-1.035,25.259.646,5.957,4.324,17.607,6.083,23.665.985,3.392-1.664,14.649-1.175,18.878,2.074-.377,3.989-1.009,5.607-1.463-.836-25.3-5.032-45.334-5.757-67.259C749.274,382.8,751.911,355.68,751.25,335.7Z",
    transform: "translate(262.962 114.983)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102762",
    "data-name": "Path 102762",
    d: "M748.527,284.642c-8.306,0-28.228.744-29.6,15.062-.558,5.84-3.065,72.139-2.279,73.948,1.571,3.6,53.248,3.146,53.9.524.758-3.039,2.615-47.513,3.748-61.182C775.355,300.35,769.645,284.642,748.527,284.642Z",
    transform: "translate(245.908 79.865)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102763",
    "data-name": "Path 102763",
    d: "M721.419,333.516c-1.159,5.989,7.149,6.472,9.814,5.555,3.488-1.206,9.5-5.76,15.882-15.092,11.269-16.478,14.039-21,14.039-21L745.432,292.53S722.579,327.532,721.419,333.516Z",
    transform: "translate(249.384 85.564)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102764",
    "data-name": "Path 102764",
    d: "M722.1,337.042c2.267,2,6.739,2.04,8.561,1.411,3.488-1.206,9.5-5.76,15.882-15.092,11.269-16.478,14.039-21,14.039-21l-1.544-8.975C756,305.859,736.689,328.574,722.1,337.042Z",
    transform: "translate(249.956 86.183)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102765",
    "data-name": "Path 102765",
    d: "M738.086,284.659a37.479,37.479,0,0,0-7.137,1.24c13.626,4.677,27.937,8.449,26.358,23.421-.475,4.553-7.257,19.634-7.485,23.986-.391,7.514,5.263,7.505,2.112,11.841-4.182,5.762-5.266,3.84-6.959,8.014-2.088,5.149,7.647,6.579,5.192,12.7-2.735,6.813-8.74,5.07-11.321,10.327,11.113-.136,20.98-.849,21.267-2,.758-3.039,2.615-47.513,3.748-61.182C764.914,300.367,758.164,283.7,738.086,284.659Z",
    transform: "translate(256.35 79.848)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102766",
    "data-name": "Path 102766",
    d: "M735.292,281.832c-.432,3.981-5.941,5.437-5.941,10.108,0,3.926,16.983,5.345,17.193-.293s.693-16.184.693-16.184S735.721,277.857,735.292,281.832Z",
    transform: "translate(255.195 73.232)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102767",
    "data-name": "Path 102767",
    d: "M748.365,266.124a11.763,11.763,0,0,0-7.133-3.63,23.342,23.342,0,0,0-8.117.436,6.191,6.191,0,0,0-4.6,3.164c-2.677,5.423-3.369,11.581-4.021,17.593-.319,2.92-.617,5.988.489,8.713,1.783,4.391,7.142,7.941,11.645,6.474,10.232-3.33,14.5-13.381,14.47-14.384-.09-3.171.339-6.344.222-9.512S750.458,268.506,748.365,266.124Z",
    transform: "translate(251.475 63.724)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102768",
    "data-name": "Path 102768",
    d: "M729.21,284.9c.038,0,.079-.007.121-.012C729.289,284.894,729.248,284.9,729.21,284.9Z",
    transform: "translate(255.093 80.043)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102769",
    "data-name": "Path 102769",
    d: "M729.726,284.82a.181.181,0,0,1,.045-.007l-.007,0A.238.238,0,0,0,729.726,284.82Z",
    transform: "translate(255.466 79.986)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102770",
    "data-name": "Path 102770",
    d: "M742.23,262.857c-2.336-.4-9.151.574-10.684,7.307-.095.41-.569,3.75-.631,4.055-.338,1.814-3.871,5.259-4.208,7.514-.63,4.162,1.4,12.2,4.162,14.963a7.364,7.364,0,0,0,3.433,1.993,5.167,5.167,0,0,0,.6-.153c10.225-3.33,14.492-13.385,14.461-14.382-.091-3.177.339-6.356.229-9.517-.122-3.18-.873-6.465-2.961-8.859A8.124,8.124,0,0,0,742.23,262.857Z",
    transform: "translate(253.202 64.066)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102771",
    "data-name": "Path 102771",
    d: "M741.078,260.888c-9.638-1.32-13.5,5-16.125,5.621,7.144,5.263,18.394,2.563,18.2,4.334-1.209,11.412,2.816,11.9,3.44,13.855a11.963,11.963,0,0,0,4.472,5.483C758.415,271.718,752.5,262.452,741.078,260.888Z",
    transform: "translate(252.017 62.569)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102772",
    "data-name": "Path 102772",
    d: "M744.914,262.092a19.415,19.415,0,0,0-4.663-1.2c-7.518-1.027-11.51,2.577-14.153,4.513.129.1,9.337,3.8,18.26,2.153A2.853,2.853,0,0,0,744.914,262.092Z",
    transform: "translate(252.845 62.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102773",
    "data-name": "Path 102773",
    d: "M738.687,270.906c-3.981,1.326-8.07,6.723-2.549,9.212a5.27,5.27,0,0,0,5.219-.575,6.92,6.92,0,0,0,2.255-3.3c.563-1.617.608-3.647-.656-4.81A4.33,4.33,0,0,0,738.687,270.906Z",
    transform: "translate(258.161 69.712)",
    fill: "#f2d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102774",
    "data-name": "Path 102774",
    d: "M735.308,273.527a5.235,5.235,0,0,1,1.745,1.19,9.539,9.539,0,0,1,.9,2.326s3.985-2.851,2.136-4.489S735.308,273.527,735.308,273.527Z",
    transform: "translate(259.5 70.738)",
    fill: "#e7c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102775",
    "data-name": "Path 102775",
    d: "M737.637,283.727a4.869,4.869,0,0,0-3.764-4.35c-2.062-.594-6.978-1.671-7.843-.742-2.015,2.177-.817,4.084-1.421,5.64-1.34,3.456-2.882,5.349-2.417,7.707,1.357,6.908,10.537,12.065,18.639,7.25,7.883-4.685,4.394-14.4,3.9-17.078-1.139-6.164,4.272-11.133,4.272-11.133l-2.684-3.774S741.858,282.69,737.637,283.727Z",
    transform: "translate(249.961 67.295)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20197",
    "data-name": "Group 20197",
    transform: "translate(972.069 340.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102776",
    "data-name": "Path 102776",
    d: "M732.809,280.281c1.457,1.1,4.1-9.133,3.962-9.635a38.84,38.84,0,0,1-4.181,8.5C732.712,279.521,732.507,280.055,732.809,280.281Z",
    transform: "translate(-714.533 -270.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102777",
    "data-name": "Path 102777",
    d: "M724.627,287.412c-.382-1.943.372-5.018,1.44-5.561.512-.265,6.339-.038,6.461-1.811.11-1.59-3.28-.76-4.975-2.735-.711-.822-.165-2.3.718-3.626a3.217,3.217,0,0,0-2.241.329c-2.015,2.177-.817,4.084-1.421,5.64-1.34,3.456-2.882,5.344-2.417,7.707,1.3,6.622,9.8,11.612,17.636,7.769C732.859,296.787,725.777,293.267,724.627,287.412Z",
    transform: "translate(-722.108 -268.475)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20198",
    "data-name": "Group 20198",
    transform: "translate(970.733 356.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102778",
    "data-name": "Path 102778",
    d: "M731.768,282.332c-.885-1.115-2.851-.432-2.854,1.5-.842-.4-2.52.27-2.542,1.48a2.75,2.75,0,0,0-2.727,2.191c-1.59-.019-2.515,1.189-2.274,3.259.255,2.212.009,4.856.58,10.849.1.992-.375,10.308-.324,11.225a66.754,66.754,0,0,1,10.293-1.4c-.048-1.077-.555-10.046.057-11.715a26.642,26.642,0,0,0,1.034-10.565C732.854,287.279,732.72,283.536,731.768,282.332Z",
    transform: "translate(-721.332 -279.022)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102779",
    "data-name": "Path 102779",
    d: "M729.528,282.332c-.885-1.115-2.851-.432-2.86,1.5a2.049,2.049,0,0,0-2.238.749,1.9,1.9,0,0,1,1.385,2.388c-.739,2.758,1.018,9.888,1.523,14.642a64.631,64.631,0,0,1,.618,9.9,14.433,14.433,0,0,1,1.723-.074c-.048-1.077-.555-10.046.057-11.715a26.577,26.577,0,0,0,1.034-10.565C730.615,287.279,730.481,283.536,729.528,282.332Z",
    transform: "translate(-719.093 -279.022)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102780",
    "data-name": "Path 102780",
    d: "M730.458,283l-6.518-2.718a1.207,1.207,0,0,0-1.576.642c-.253.613.742,1.852,1.356,2.107l5.81,2.193a1.2,1.2,0,0,0,.928-2.224Z",
    transform: "translate(-720.615 -280.185)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102781",
    "data-name": "Path 102781",
    d: "M731.486,293.631a28.53,28.53,0,0,0-9.567.4.375.375,0,0,0-.3.3,10.448,10.448,0,0,0-.079,2.832.38.38,0,0,0,.479.324,23.421,23.421,0,0,1,9.43-.338.375.375,0,0,0,.45-.326,16.59,16.59,0,0,0-.079-2.849A.388.388,0,0,0,731.486,293.631Z",
    transform: "translate(249.507 86.184)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102782",
    "data-name": "Path 102782",
    d: "M679.145,266.214a.917.917,0,1,0-1.421,1.159s2.946,3.757,4.151,3.859c.32.028.832-.441.51-.83Z",
    transform: "translate(217.739 66.304)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102783",
    "data-name": "Path 102783",
    d: "M677.28,258.423c-.506-.494-1.213.16-1.216.608-.005,1.686,4.863,6.217,4.863,6.217a1.278,1.278,0,0,0,1.778-1.836Z",
    transform: "translate(216.69 60.791)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102784",
    "data-name": "Path 102784",
    d: "M680.321,263.011a1.279,1.279,0,1,0-1.671,1.936s4.951,4.439,6.625,4.282c.453-.043,1.035-.8.5-1.268Z",
    transform: "translate(218.238 64.01)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102785",
    "data-name": "Path 102785",
    d: "M679.952,264.615a1.165,1.165,0,0,0-1.519,1.767s4.51,4.05,6.038,3.907c.41-.043.944-.734.458-1.156Z",
    transform: "translate(218.107 65.191)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102786",
    "data-name": "Path 102786",
    d: "M722.323,297.329s-1.509,15.638-2.027,22.418a34.16,34.16,0,0,0,1.724,13c1.394,4.2,14.167,7.257,13.521-6.6-.429-9.149-2.52-29.246-2.52-29.246A35.224,35.224,0,0,0,722.323,297.329Z",
    transform: "translate(248.594 88.591)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102787",
    "data-name": "Path 102787",
    d: "M730.986,296.9c-1.523-.133-2.9-.183-4.126-.179a6.338,6.338,0,0,1,1.063,2.687c1.475,10.542,6.244,22.947-.5,32.667a9.091,9.091,0,0,1-4.4,3.475c4.179,1.828,10.951.784,10.475-9.4C733.077,317,730.986,296.9,730.986,296.9Z",
    transform: "translate(250.628 88.592)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102788",
    "data-name": "Path 102788",
    d: "M726.236,292.511a3.114,3.114,0,1,0,3.258,2.968A3.118,3.118,0,0,0,726.236,292.511Z",
    transform: "translate(250.8 85.549)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102789",
    "data-name": "Path 102789",
    d: "M725.932,292.991a2.289,2.289,0,1,0,2.391,2.177A2.289,2.289,0,0,0,725.932,292.991Z",
    transform: "translate(251.145 85.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102790",
    "data-name": "Path 102790",
    d: "M493.094,434.782h183.07l19.812-227H512.905Z",
    transform: "translate(84.474 24.323)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102791",
    "data-name": "Path 102791",
    d: "M589.6,452.567,749.245,446.1l18.29-271L606.261,236.009Z",
    transform: "translate(154.21 0.709)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102792",
    "data-name": "Path 102792",
    d: "M516.416,216.164,497.459,433.356H654.387l18.957-217.191C626.043,186.468,561.07,216.164,516.416,216.164Z",
    transform: "translate(87.629 20.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102793",
    "data-name": "Path 102793",
    d: "M498.535,335.009l-1.068,12.48H654.376l1.108-12.48C608.163,305.328,543.192,335.009,498.535,335.009Z",
    transform: "translate(87.634 106.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102794",
    "data-name": "Path 102794",
    d: "M498.535,335.009l-1.068,12.48H654.376l1.108-12.48C608.163,305.328,543.192,335.009,498.535,335.009Z",
    transform: "translate(87.634 106.728)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102795",
    "data-name": "Path 102795",
    d: "M589.328,451.493,730.75,440.125,748.969,176.6,606.914,234.966Z",
    transform: "translate(154.013 1.791)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102796",
    "data-name": "Path 102796",
    d: "M589.328,452.34l124.331-11.232,18.759-265.682-125.5,60.387Z",
    transform: "translate(154.013 0.944)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102797",
    "data-name": "Path 102797",
    d: "M589.328,453.284,694.53,442.2,713.9,174.119,606.914,236.757Z",
    transform: "translate(154.013)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102798",
    "data-name": "Path 102798",
    d: "M671.425,440.125l12.358-.1,17.829-261.976L689.645,176.6Z",
    transform: "translate(213.338 1.791)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102799",
    "data-name": "Path 102799",
    d: "M682.276,446.1l6.567-.071,18.081-270.147-6.358-.784Z",
    transform: "translate(221.178 0.709)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20199",
    "data-name": "Group 20199",
    transform: "translate(608.953 240.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102800",
    "data-name": "Path 102800",
    d: "M518.893,220.533q10.473-.848,20.918-1.447c.139-1.8.281-3.6.424-5.4q-10.452.6-20.938,1.456Q519.095,217.839,518.893,220.533Z",
    transform: "translate(-505.836 -212.238)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102801",
    "data-name": "Path 102801",
    d: "M518.48,226.228q15.788-1.266,31.5-1.955.217-2.705.434-5.407-15.726.7-31.529,1.974Q518.683,223.533,518.48,226.228Z",
    transform: "translate(-506.134 -208.495)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102802",
    "data-name": "Path 102802",
    d: "M535.7,219.237q14.971-.721,29.861-.916.227-2.716.456-5.426-14.9.209-29.887.935Q535.917,216.532,535.7,219.237Z",
    transform: "translate(-493.689 -212.81)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102803",
    "data-name": "Path 102803",
    d: "M555.6,218.309q8.124-.078,16.218.016.238-2.716.479-5.435-8.106-.083-16.236-.012C555.907,214.688,555.754,216.493,555.6,218.309Z",
    transform: "translate(-479.312 -212.845)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102804",
    "data-name": "Path 102804",
    d: "M567.986,218.352q9.855.163,19.66.558.253-2.729.5-5.45-9.816-.388-19.677-.551Q568.227,215.63,567.986,218.352Z",
    transform: "translate(-470.361 -212.799)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102805",
    "data-name": "Path 102805",
    d: "M553.471,218.431q-.23,2.711-.46,5.423,17.3-.194,34.475.3.248-2.723.494-5.443Q570.792,218.218,553.471,218.431Z",
    transform: "translate(-481.182 -208.855)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102806",
    "data-name": "Path 102806",
    d: "M518.068,231.461q10.444-.824,20.852-1.4.209-2.7.426-5.4-10.419.579-20.87,1.413C518.342,227.868,518.2,229.663,518.068,231.461Z",
    transform: "translate(-506.432 -204.31)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102807",
    "data-name": "Path 102807",
    d: "M517.654,237.467q31.366-2.447,62.426-2.634c.155-1.807.312-3.621.469-5.426q-31.069.2-62.486,2.672C517.928,233.874,517.788,235.672,517.654,237.467Z",
    transform: "translate(-506.731 -200.878)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102808",
    "data-name": "Path 102808",
    d: "M534.825,230.22q19.214-.886,38.287-.915.24-2.713.472-5.43-19.093.041-38.328.932C535.116,226.615,534.968,228.417,534.825,230.22Z",
    transform: "translate(-494.323 -204.874)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102809",
    "data-name": "Path 102809",
    d: "M560.6,229.315q10.3.059,20.544.367.251-2.721.5-5.447-10.258-.3-20.566-.355Q560.835,226.6,560.6,229.315Z",
    transform: "translate(-475.701 -204.871)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102810",
    "data-name": "Path 102810",
    d: "M576.584,229.675q12.527.478,24.978,1.338.261-2.729.527-5.462-12.462-.85-25-1.326Q576.834,226.951,576.584,229.675Z",
    transform: "translate(-464.148 -204.622)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102811",
    "data-name": "Path 102811",
    d: "M557.433,234.83q17.664.018,35.195.78.251-2.726.5-5.454-17.542-.749-35.226-.761Q557.672,232.111,557.433,234.83Z",
    transform: "translate(-477.986 -200.886)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102812",
    "data-name": "Path 102812",
    d: "M539.914,224.337q7.757-.292,15.491-.444.225-2.711.451-5.423-7.736.158-15.5.455Q540.133,221.635,539.914,224.337Z",
    transform: "translate(-490.646 -208.781)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102813",
    "data-name": "Path 102813",
    d: "M514.384,279.409q10.292-.723,20.556-1.206l.439-5.409q-10.271.486-20.577,1.218Q514.593,276.717,514.384,279.409Z",
    transform: "translate(-509.094 -169.526)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102814",
    "data-name": "Path 102814",
    d: "M513.957,285.063q15.509-1.083,30.95-1.6.225-2.708.45-5.414-15.449.527-30.981,1.619C514.236,281.461,514.095,283.265,513.957,285.063Z",
    transform: "translate(-509.402 -165.729)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102815",
    "data-name": "Path 102815",
    d: "M530.9,278.268q14.71-.556,29.338-.594.235-2.713.474-5.43-14.64.049-29.363.613Q531.124,275.56,530.9,278.268Z",
    transform: "translate(-497.159 -169.923)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102816",
    "data-name": "Path 102816",
    d: "M550.448,277.674q7.976.016,15.929.19c.164-1.814.331-3.631.493-5.442q-7.956-.165-15.943-.181Q550.689,274.957,550.448,277.674Z",
    transform: "translate(-483.034 -169.925)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102817",
    "data-name": "Path 102817",
    d: "M562.614,277.859q9.674.271,19.305.758.258-2.726.517-5.454-9.638-.486-19.321-.749Q562.862,275.143,562.614,277.859Z",
    transform: "translate(-474.243 -169.8)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102818",
    "data-name": "Path 102818",
    d: "M547.881,283.195q16.994-.018,33.858.655.256-2.726.51-5.449-16.881-.669-33.892-.637Q548.119,280.479,547.881,283.195Z",
    transform: "translate(-484.889 -165.936)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102819",
    "data-name": "Path 102819",
    d: "M513.526,290.351q10.263-.7,20.489-1.163.225-2.7.443-5.412-10.235.47-20.508,1.178Q513.741,287.654,513.526,290.351Z",
    transform: "translate(-509.714 -161.59)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102820",
    "data-name": "Path 102820",
    d: "M513.1,296.181q30.823-2.09,61.328-1.948.24-2.716.482-5.433-30.514-.132-61.385,1.981Q513.307,293.478,513.1,296.181Z",
    transform: "translate(-510.025 -157.966)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102821",
    "data-name": "Path 102821",
    d: "M529.992,289.237q18.87-.672,37.61-.5.243-2.713.486-5.433-18.749-.16-37.647.522Q530.218,286.528,529.992,289.237Z",
    transform: "translate(-497.815 -161.956)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102822",
    "data-name": "Path 102822",
    d: "M555.306,288.768q10.105.168,20.177.579.253-2.729.51-5.45-10.077-.408-20.2-.565Q555.55,286.052,555.306,288.768Z",
    transform: "translate(-479.523 -161.912)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102823",
    "data-name": "Path 102823",
    d: "M571.006,289.291q12.3.607,24.521,1.58.269-2.734.539-5.466-12.23-.972-24.545-1.569C571.352,285.656,571.175,287.471,571.006,289.291Z",
    transform: "translate(-468.178 -161.548)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102824",
    "data-name": "Path 102824",
    d: "M552.175,294.258q17.346.207,34.557,1.135c.171-1.819.348-3.636.52-5.455q-17.219-.925-34.588-1.115Q552.419,291.539,552.175,294.258Z",
    transform: "translate(-481.786 -157.943)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102825",
    "data-name": "Path 102825",
    d: "M535.015,283.49q7.623-.2,15.217-.276.235-2.716.472-5.428-7.6.075-15.233.284Q535.244,280.781,535.015,283.49Z",
    transform: "translate(-494.186 -165.919)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102826",
    "data-name": "Path 102826",
    d: "M512.62,301.847q10.227-.682,20.42-1.118.222-2.705.443-5.414-10.2.447-20.435,1.133Q512.838,299.146,512.62,301.847Z",
    transform: "translate(-510.369 -153.252)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102827",
    "data-name": "Path 102827",
    d: "M512.186,307.483q15.413-1.013,30.745-1.468.227-2.711.453-5.418-15.343.46-30.771,1.485C512.472,303.883,512.329,305.687,512.186,307.483Z",
    transform: "translate(-510.682 -149.435)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102828",
    "data-name": "Path 102828",
    d: "M529.028,300.761q14.607-.486,29.136-.472.24-2.716.481-5.435-14.54-.005-29.166.493Q529.257,298.055,529.028,300.761Z",
    transform: "translate(-498.512 -153.585)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102829",
    "data-name": "Path 102829",
    d: "M548.44,300.3q7.925.044,15.819.248.248-2.721.5-5.443-7.9-.2-15.834-.241Q548.683,297.579,548.44,300.3Z",
    transform: "translate(-484.485 -153.579)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102830",
    "data-name": "Path 102830",
    d: "M560.522,300.532q9.607.3,19.171.83.261-2.726.522-5.459-9.568-.522-19.188-.818Q560.776,297.806,560.522,300.532Z",
    transform: "translate(-475.754 -153.418)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102831",
    "data-name": "Path 102831",
    d: "M545.881,305.811q16.878.052,33.624.785.256-2.721.517-5.45-16.765-.723-33.656-.768Q546.122,303.094,545.881,305.811Z",
    transform: "translate(-486.334 -149.594)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102832",
    "data-name": "Path 102832",
    d: "M511.752,312.79q10.194-.656,20.351-1.073c.148-1.807.3-3.607.448-5.414q-10.168.426-20.372,1.089Q511.967,310.089,511.752,312.79Z",
    transform: "translate(-510.996 -145.312)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102833",
    "data-name": "Path 102833",
    d: "M511.313,318.562q30.624-1.956,60.911-1.7.246-2.716.489-5.435-30.3-.245-60.968,1.73Q511.531,315.86,511.313,318.562Z",
    transform: "translate(-511.313 -141.625)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102834",
    "data-name": "Path 102834",
    d: "M528.56,306.322q-.227,2.705-.455,5.414,18.744-.592,37.353-.348c.164-1.814.329-3.623.491-5.437Q547.332,305.714,528.56,306.322Z",
    transform: "translate(-499.179 -145.615)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102835",
    "data-name": "Path 102835",
    d: "M553.244,311.417q10.043.212,20.037.656c.172-1.817.345-3.638.515-5.45q-10-.45-20.053-.644Q553.49,308.7,553.244,311.417Z",
    transform: "translate(-481.013 -145.546)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102836",
    "data-name": "Path 102836",
    d: "M568.834,312q12.214.649,24.347,1.669.274-2.734.549-5.471-12.149-1.005-24.371-1.652Q569.1,309.272,568.834,312Z",
    transform: "translate(-469.748 -145.137)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102837",
    "data-name": "Path 102837",
    d: "M550.126,316.9q17.229.274,34.316,1.266c.172-1.817.351-3.64.527-5.459q-17.1-.979-34.347-1.247Q550.374,314.178,550.126,316.9Z",
    transform: "translate(-483.267 -141.584)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102838",
    "data-name": "Path 102838",
    d: "M533.1,306.03q7.563-.173,15.114-.214.238-2.716.474-5.431-7.55.041-15.128.227Z",
    transform: "translate(-495.566 -149.588)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102839",
    "data-name": "Path 102839",
    d: "M528.067,246.909q9.1-.493,18.165-.792.225-2.7.446-5.416-9.077.3-18.18.8Q528.281,244.2,528.067,246.909Z",
    transform: "translate(-499.206 -192.716)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102840",
    "data-name": "Path 102840",
    d: "M544.661,240.636q-.225,2.711-.455,5.419,27.408-.592,54.507.577.256-2.726.51-5.45Q572.1,240.024,544.661,240.636Z",
    transform: "translate(-487.544 -192.917)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102841",
    "data-name": "Path 102841",
    d: "M516.4,253.584q17.646-1.323,35.193-1.931c.148-1.805.3-3.612.445-5.414q-17.558.615-35.226,1.955C516.671,249.991,516.533,251.791,516.4,253.584Z",
    transform: "translate(-507.639 -188.715)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102842",
    "data-name": "Path 102842",
    d: "M515.982,259.111q19.607-1.457,39.1-2.022.228-2.713.451-5.421-19.5.579-39.134,2.046C516.256,255.515,516.12,257.308,515.982,259.111Z",
    transform: "translate(-507.939 -184.792)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102843",
    "data-name": "Path 102843",
    d: "M515.559,264.408q13.568-.995,27.079-1.566.22-2.713.441-5.433-13.516.576-27.1,1.581C515.84,260.8,515.7,262.6,515.559,264.408Z",
    transform: "translate(-508.245 -180.643)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102844",
    "data-name": "Path 102844",
    d: "M543.735,251.629q-.227,2.708-.458,5.421,14.622-.284,29.159-.069.243-2.723.486-5.442Q558.371,251.328,543.735,251.629Z",
    transform: "translate(-488.216 -184.948)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102845",
    "data-name": "Path 102845",
    d: "M535.261,257.495q-.222,2.721-.448,5.44,25.2-.878,50.14-.267.251-2.734.5-5.466Q560.488,256.6,535.261,257.495Z",
    transform: "translate(-494.332 -180.967)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102846",
    "data-name": "Path 102846",
    d: "M566.776,262.643q6.8.212,13.564.527c.169-1.826.344-3.652.513-5.476q-6.772-.32-13.576-.515Q567.027,259.908,566.776,262.643Z",
    transform: "translate(-471.235 -180.809)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102847",
    "data-name": "Path 102847",
    d: "M527.436,268.824q12.594-.6,25.135-.83.23-2.716.46-5.423-12.553.233-25.159.846C527.729,265.219,527.582,267.026,527.436,268.824Z",
    transform: "translate(-499.662 -176.913)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102848",
    "data-name": "Path 102848",
    d: "M544.828,262.568q-.235,2.71-.467,5.424,22.782-.31,45.341.608.256-2.726.512-5.45Q567.633,262.244,544.828,262.568Z",
    transform: "translate(-487.432 -176.978)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102849",
    "data-name": "Path 102849",
    d: "M573.746,268.453q7.17.341,14.31.8.264-2.734.525-5.457-7.144-.46-14.322-.794Q574.006,265.727,573.746,268.453Z",
    transform: "translate(-466.199 -176.601)",
    fill: "#c5d9f2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102850",
    "data-name": "Path 102850",
    d: "M464.245,292.53a7.568,7.568,0,0,0,2.849,10.112c7.834,4.6,20.527,11.135,30.089,12.937l4.238-8.489c-3.917-1.938-14.461-10.467-26.694-17.55A7.585,7.585,0,0,0,464.245,292.53Z",
    transform: "translate(62.977 82.667)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102851",
    "data-name": "Path 102851",
    d: "M528.793,293.572c-2.834.9-1.29-2.1-3.545-1.04a11.291,11.291,0,0,0-5.819,5.45c-.632,1.3-22.964,5.66-32.981,6.737-3.435.37-4.684,6.789-2.5,8.22,5.5,3.616,28.736-5.617,35.787-7.748,5.38-1.623,8.317-3.152,10.315-3.714,1.879-.524,2.665-1.385,2.088-2.754a1.806,1.806,0,0,0,.877-2.517,1.333,1.333,0,0,0,.389-2.233c1.671-.691,3.09-1.368,2.21-2.487C535.179,290.935,530.467,293.043,528.793,293.572Z",
    transform: "translate(77.08 84.744)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102852",
    "data-name": "Path 102852",
    d: "M484.142,300.644c-3.435.365-3.96,8.182-1.779,9.612,5.452,3.586,31.515-4.639,38.71-6.847-1.252-1.657-2.422-6.1-2.715-8.134C518.081,295.373,494.161,299.564,484.142,300.644Z",
    transform: "translate(75.777 87.548)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102853",
    "data-name": "Path 102853",
    d: "M532.476,305.045c-8.408,4.81-23.6,7.991-32.736,5.729-.732-.181-3.821-1.158-4.57-1.449-.282-.115-.577-.231-.863-.348-9.662-3.848-21.57-8.444-28.208-16.253-.176-.212-2.825-3.879-3-4.089-.3.372,1.583,3.371,1.349,3.812a7.568,7.568,0,0,0,2.849,10.112c7.292,4.282,18.794,10.234,28.061,12.492l.007,0c5.452,3.586,31.515-4.639,38.71-6.847a12.452,12.452,0,0,1-1.485-3.226Z",
    transform: "translate(62.775 82.75)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102854",
    "data-name": "Path 102854",
    d: "M509.232,292.211l-4.036,4.265,3.245-.315a6.6,6.6,0,0,0,2.689-3.015c1.836-.777,2.587-2.107,2.188-3.5A19.781,19.781,0,0,1,509.232,292.211Z",
    transform: "translate(93.219 83.483)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102855",
    "data-name": "Path 102855",
    d: "M545.641,369.473c-11.2,3.058-17.111,19.962-22.271,29.942,0,0,3.464,7.185,16.306,8.1,0,0,13.221-21.1,13.3-26.442S547.892,368.863,545.641,369.473Z",
    transform: "translate(106.351 141.136)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102856",
    "data-name": "Path 102856",
    d: "M543.746,369.473a14.221,14.221,0,0,0-1.893.675,3.787,3.787,0,0,1,.581,2.17c-.181,11.352-7.633,22.713-16.442,31.629a24.471,24.471,0,0,0,11.789,3.566s13.221-21.1,13.3-26.442S546,368.863,543.746,369.473Z",
    transform: "translate(108.246 141.136)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102857",
    "data-name": "Path 102857",
    d: "M539.9,373.557c-3.471,2.355-.295,41.906-3.554,48.08-5.18,9.805-11.522,21.638-11.522,21.638,13.553,7.991,65.631,7.96,65.631,7.96a183.283,183.283,0,0,0,5.063-24.85c2.57-17.965,3.447-57.1,2.443-57.361C576.071,363.268,545.968,369.442,539.9,373.557Z",
    transform: "translate(107.403 139.149)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20200",
    "data-name": "Group 20200",
    transform: "translate(665.498 483.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102858",
    "data-name": "Path 102858",
    d: "M564.976,353.633,545.1,365.986c.391.865,1.473,8.53.007,12.21-1.254,3.152-2.477,7.927,4.55,9.44,6.546,1.409,18.682-4.6,17.064-10.015C563.9,368.191,564.976,353.633,564.976,353.633Z",
    transform: "translate(-544.138 -353.633)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102859",
    "data-name": "Path 102859",
    d: "M564.8,353.633l-19.879,12.353c.391.865,1.473,8.53.007,12.21-.2.5-.391,1.047-.556,1.611a16.519,16.519,0,0,0,6.932-2.823c3.547-2.475,7.505-1.147,10.268,2.289a7.212,7.212,0,0,1,1.44,4.673c2.568-1.852,4.181-4.136,3.526-6.325C563.724,368.191,564.8,353.633,564.8,353.633Z",
    transform: "translate(-543.967 -353.633)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102860",
    "data-name": "Path 102860",
    d: "M583.828,367.673c-6.739-.989-18.434,9.7-19.024,26.642-.157,4.5-1.44,10.251-5.221,17.328-2.121,3.969-10.756,7.249-14.47,8.541s-4.229,2.935-2.07,4.072,19.2,3.915,17.1,6.523c-2.232,2.777-22.988,7.374-19.2,16.334,1.829,4.327,33.338,1.228,39.146-.057,1.916-3.516,2.14-12.008,3.388-17.348,2.594-11.04,1.747-34.686,3.33-47.285C587.68,373.97,591.2,368.754,583.828,367.673Z",
    transform: "translate(118.717 139.817)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102861",
    "data-name": "Path 102861",
    d: "M538.835,421.155c-.948.1-14.451-.858-19.846-.227s-7.586.755-10.777,4.327-2.1,9.691-.424,14.022,3.981,4.4,8.174,3.213,8.778-4.512,13.013-4.937,5.3.338,8.277-.532,3.557.122,3.245-2.05S538.835,421.155,538.835,421.155Z",
    transform: "translate(93.923 178.189)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102862",
    "data-name": "Path 102862",
    d: "M538.832,421.155c-.948.1-14.451-.858-19.846-.227s-7.586.755-10.777,4.327c-1.726,1.943-2.193,4.622-1.995,7.369a18.674,18.674,0,0,0,9.247-.122c2.76-.593,5.7-1.68,8.56-1.144,3.035.581,6.735,2.956,7.859,6.062,2.058.009,3.225.229,5.369-.4,2.978-.873,3.557.122,3.245-2.05S538.832,421.155,538.832,421.155Z",
    transform: "translate(93.925 178.189)",
    fill: "#0e182a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102863",
    "data-name": "Path 102863",
    d: "M513.176,423.079c1.814-1.2,5.356-1.919,8.322-2.343-.946.038-1.8.09-2.51.174-5.4.632-7.586.755-10.777,4.327s-2.1,9.691-.424,14.022c1.518,3.929,3.55,4.348,7.028,3.512C509.168,438.034,506.005,427.814,513.176,423.079Z",
    transform: "translate(93.923 178.207)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102864",
    "data-name": "Path 102864",
    d: "M579.742,421.845c-3.1-.493-13.4-.4-21.3-1.545,0,0-8.38,11.879-8.579,12.151s6.284,3.828,8.946,5.914,13.305,5.691,16.256,5.139,8.391-12.256,9.492-16.47S582.844,422.34,579.742,421.845Z",
    transform: "translate(125.494 177.892)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102865",
    "data-name": "Path 102865",
    d: "M579.681,421.845c-3.1-.493-13.4-.4-21.3-1.545,0,0-7.319,10.374-8.437,11.955,3.654.059,7.147-1.869,10.892-1.27,1.878.3,4.083,2.761,9.529,2.112,3.306-.4,2.68,5.14-.186,7.921a8.915,8.915,0,0,1-1.872,1.376c2.818.827,5.447,1.344,6.7,1.109,2.951-.555,8.391-12.256,9.492-16.47S582.783,422.34,579.681,421.845Z",
    transform: "translate(125.555 177.892)",
    fill: "#0e182a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102866",
    "data-name": "Path 102866",
    d: "M514.151,405.77c-7.559,1.587-10.484,7.374-10.472,13.8.009,3.838,3.4,7.991,7.647,9.287s70.136,16.339,72.008,16.792,9.734-18.689,9.734-18.689C590.691,426.12,528.448,402.773,514.151,405.77Z",
    transform: "translate(92.123 167.201)",
    fill: "#4e72b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102867",
    "data-name": "Path 102867",
    d: "M534.1,419.36c-13.781.438-18.308-1.428-30.116-7.7a18.861,18.861,0,0,0-.3,3.464c.009,3.838,3.4,7.991,7.647,9.287s70.136,16.339,72.008,16.792,9.734-18.689,9.734-18.689c-.873-.307-19.572-6.88-31.286-10.854C552.475,416.215,544.414,419.025,534.1,419.36Z",
    transform: "translate(92.123 171.646)",
    fill: "rgba(80,135,208,0.96)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102868",
    "data-name": "Path 102868",
    d: "M536.835,343.56a10.272,10.272,0,0,0-3.326,6.045c-.372,3.564,3.66,9.243,3.66,9.243s3.795-9.679,3.251-12.467C540.311,345.83,536.835,343.56,536.835,343.56Z",
    transform: "translate(113.66 122.439)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102869",
    "data-name": "Path 102869",
    d: "M546.074,369.73l.624-1.835s-3.977-.424-4.6,4.84a25.526,25.526,0,0,0,3.144,15.462c.653-4.732,6.246-10.765,6.246-10.765C545.752,374.753,546.074,369.73,546.074,369.73Z",
    transform: "translate(119.766 140.018)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102870",
    "data-name": "Path 102870",
    d: "M577.117,358.584c-1.773-3.2-4.839-.534-4.839-.534s-.66-8.158-6.475-13.485-11.671-3.077-22.11.005-8.415,6.382-8.415,6.382a143.765,143.765,0,0,0,1.96,17.248c.651,3.581,4.673,8.487,8.973,13.8,4.16,5.137,10.027,2.263,17.614-2.193s7.135-8.868,7.1-9.686c0,0,1.289.591,3.692-1.144s4.4-6.36,2.661-10.063C577.228,358.8,577.172,358.688,577.117,358.584Z",
    transform: "translate(114.843 120.849)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102871",
    "data-name": "Path 102871",
    d: "M572.553,357.378c-1.773-3.2-4.839-.534-4.839-.534s-.66-8.158-6.475-13.485c-1.328-1.213-8.069,1.042-7.216,4.543.953,3.9,4.121,6.556,4.737,10.258.711,4.269,1.826,12.179-.746,15.769-3.719,5.182-10.167,9.324-16.578,6.6.071.091.141.174.212.264,4.16,5.137,10.027,2.263,17.614-2.193s7.135-8.868,7.1-9.686c0,0,1.289.591,3.692-1.144s4.4-6.36,2.661-10.063C572.665,357.59,572.608,357.482,572.553,357.378Z",
    transform: "translate(119.407 122.055)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102872",
    "data-name": "Path 102872",
    d: "M535.2,346.841c-1.314,2.763-2.627,11.814,4.859,13.857,8.251,2.258,22.811-8.184,26.029-2.136,2.63,4.94-.517,8.212,1.843,10.165a2.115,2.115,0,0,0,3.421-.693c.21-.477-.084-4.138,1.609-6.53a4.607,4.607,0,0,1,2.608-1.039,19.149,19.149,0,0,0-.693-11.323C566.919,330.456,540.781,335.145,535.2,346.841Z",
    transform: "translate(114.164 117.396)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102873",
    "data-name": "Path 102873",
    d: "M547.968,336.678c5.316,3.747-1.488,12.47,3.805,16.761,4.692,3.81,6.816,4.978,6.725,7.869a68.006,68.006,0,0,1-.906,6.973,2.468,2.468,0,0,0,.372.376,2.115,2.115,0,0,0,3.421-.693c.21-.477-.084-4.138,1.609-6.53a4.607,4.607,0,0,1,2.608-1.039,19.148,19.148,0,0,0-.693-11.323C561.542,341.164,554.914,337.451,547.968,336.678Z",
    transform: "translate(124.127 117.466)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102874",
    "data-name": "Path 102874",
    d: "M602.359,407.262c-7.564-4.429-21.2.989-36.373,5.786-11.877,3.759-44.819,15.05-44.819,15.05s-3.306,14,5.723,22.533c0,0,45.48-10.933,74.751-23.457,2.16-.922,5.34-2.208,6.3-6.98S606.537,409.715,602.359,407.262Z",
    transform: "translate(104.334 167.284)",
    fill: "#4e72b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102875",
    "data-name": "Path 102875",
    d: "M603.386,407c1.087,2.68,1.106,5.893-.531,9.591a12.156,12.156,0,0,1-12.89,6.916c-2.3-.326-3.929-2-6.032-2.4-3.662-.67-5.223,1.087-8,3.4-4.193,3.5-7.552,6.71-13.09,7.855-3.094.636-5.965-.093-9.021.162-3.876.322-6.71,2.5-10.4,3.571-7.995,2.327-15.488.45-22.838-2.293.1,4.763,1.325,11.121,6.3,15.822,0,0,45.48-10.933,74.751-23.457,2.16-.922,5.34-2.208,6.3-6.98A12.927,12.927,0,0,0,603.386,407Z",
    transform: "translate(104.339 168.284)",
    fill: "rgba(80,135,208,0.96)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102876",
    "data-name": "Path 102876",
    d: "M557.24,353.58a2.783,2.783,0,0,0-.165,2.312c.339.9.579.45.649,1.316s-.849.477-1.118,1.4-.071,1.574.911,1.8,2.081-.641,2.906-2.551,1.1-4.42.25-5.552C559.672,350.972,557.71,352.162,557.24,353.58Z",
    transform: "translate(130.289 128.339)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102877",
    "data-name": "Path 102877",
    d: "M571.655,421.249c2.47,1.974-4.322,18.647-9.855,21.014a13.331,13.331,0,0,0,4.639.555c2.951-.555,8.391-12.256,9.492-16.47C576.971,422.383,574.532,421.718,571.655,421.249Z",
    transform: "translate(134.122 178.578)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20201",
    "data-name": "Group 20201",
    transform: "translate(646.386 512.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102878",
    "data-name": "Path 102878",
    d: "M584.247,376.34c-1.326,9.417,12.714,33.887,12.714,33.887s-34.533-8.11-37.983-8.456c-5.58-.558-12.06-5.368-14.177-5.2a40.776,40.776,0,0,0-5.08,1.922c-.233.169-7.254,5.941-6.639,7.245.215.455,1.755-.095,2.179-.344,1.242-.758,3.991-3.523,5.166-4.081a21.194,21.194,0,0,1,5.273-1.271s-3.273,1.559-4.267,2.239a34.539,34.539,0,0,0-6.088,5.914c-.465.617-.581,1.161-.27,1.3.443.21,1.245-.074,2.074-.45,1.438-.641,3.257-2.8,3.659-3.14s3.752-2.041,3.752-2.041-3.559,3.74-4.208,4.673c-.8,1.14-2.949,4.375-2.155,4.751.419.193,1.075-.381,1.878-1,1.757-1.344,2.789-3.363,3.542-3.817a28.265,28.265,0,0,1,3.991-2.127,10,10,0,0,0-2.041,2.336c-.334.739-1.283,2.98-1.283,2.98s-.451,3.375.56,3.12c1.1-.281,1.836-3.583,1.836-3.583a4.526,4.526,0,0,0,1.256-1.347,29.748,29.748,0,0,0,7.719,1.492c3.655.088,5.388-1.375,5.388-1.375h.01c.3,1.163,39.716,12.961,43.646,13.791,4.01.851,7.125-1.847,7.433-3.254,1.531-7-7.232-28.37-12.985-43.222C593.864,363.643,584.614,373.748,584.247,376.34Z",
    transform: "translate(-533.044 -370.306)",
    fill: "#f2d6d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102879",
    "data-name": "Path 102879",
    d: "M579.466,376.34c-1.142,8.1,9.073,27.314,11.962,32.54a10.831,10.831,0,0,0,5.831-1.142c4.984-2.346,11.545,5.33,4.136,10.008-4.961,3.127-12.771.475-44.557-10.024-2.982-.98-6.231,1.242-8.346,1.213-1.1-.021-3.559-1.38-4.935-.5-2.334,1.482-2.7,3.116-3.521,5.695a.753.753,0,0,1-.376.455.363.363,0,0,0,.4.208c1.1-.281,1.836-3.583,1.836-3.583a4.526,4.526,0,0,0,1.256-1.347,29.749,29.749,0,0,0,7.719,1.492c3.655.088,5.388-1.375,5.388-1.375h.01c.3,1.163,39.716,12.961,43.646,13.791,4.01.851,7.125-1.847,7.433-3.254,1.531-7-7.231-28.37-12.985-43.222C589.083,363.643,579.833,373.748,579.466,376.34Z",
    transform: "translate(-528.263 -370.306)",
    fill: "#e7c8ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102880",
    "data-name": "Path 102880",
    d: "M567.96,367.8c-10.332,2.045-11.345,15,6.555,41.5,0,0,11.026-.765,16.914-6.312C591.428,403,579.53,365.506,567.96,367.8Z",
    transform: "translate(133.216 139.884)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102881",
    "data-name": "Path 102881",
    d: "M567.716,367.778a4.4,4.4,0,0,1,.879,1.878,36.3,36.3,0,0,1-4.625,26.2,135.87,135.87,0,0,0,8.072,13.4s11.026-.765,16.914-6.312C588.955,402.942,578.537,370.121,567.716,367.778Z",
    transform: "translate(135.689 139.939)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102882",
    "data-name": "Path 102882",
    d: "M563.15,364.05l.658,3.867s-8.179,13.247-16.468,12.191c0,0,6.678,6.155,8.532,11.273,0,0,10.055-9.805,11.164-18.885C567.817,366.09,563.15,364.05,563.15,364.05Z",
    transform: "translate(123.673 137.245)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20202",
    "data-name": "Group 20202",
    transform: "translate(648.833 570.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102883",
    "data-name": "Path 102883",
    d: "M534.464,404.391v.01a2.754,2.754,0,0,0,2.748,2.748h64.6a2.754,2.754,0,0,0,2.744-2.748l0-.01Z",
    transform: "translate(-534.464 -404.391)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_102884",
    "data-name": "Path 102884",
    d: "M549.121,372.871a5.01,5.01,0,0,0-4.956-3.681l-39.637-.012V431.91l54.734.684c3.352,0,3.549-2.589,3.323-3.487Z",
    transform: "translate(92.737 140.951)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102885",
    "data-name": "Path 102885",
    d: "M559.441,370.35a1.616,1.616,0,0,0-1.556-1.182H487.921a1.614,1.614,0,0,0-1.554,2.045l13.125,55.566a7.939,7.939,0,0,0,7.655,5.822H572.3a1.611,1.611,0,0,0,1.552-2.038Z",
    transform: "translate(79.571 140.944)",
    fill: "#c5d9f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbook);
export default __webpack_public_path__ + "static/media/ebook.09c296825f4c5592f63f3b02318ff48f.svg";
export { ForwardRef as ReactComponent };